<template>
  <section role="modal">
    <div
      class="modal fade"
      id="protocoloModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="protocoloModalLabel"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title" id="protocoloModalLabel">
              Protocolo Gerado
            </h4>
          </div>
          <div class="modal-body">
            <div class="row row-field" style="padding-bottom: 15px">
              <div class="row row-field" v-if="protocoloGerado">
                <p>
                  O presente <strong>protocolo</strong> é um arquivo
                  <strong>pessoal</strong>. Não é necessário entregar em nenhum
                  setor de Departamento de qualquer Secretaria.
                </p>
                <p>Anote ou imprima o seu número.</p>
                <div class="espacado" style="color: #004f4a">
                  <h2>PROTOCOLO</h2>
                  <h2 style="margin-top: 10px; padding-bottom: 10px">
                    {{ protocoloGerado }}
                  </h2>
                </div>
              </div>
              <div v-else>
                <div
                  class="alert alert-warning espacado"
                  role="alert"
                  style="text-align: center; margin: 30px 30px 15px"
                >
                  <i class="fa fa-flag-o fa-lg"></i>&nbsp; Este agendamento é
                  anterior à criação de protocolos. Não existe protocolo para
                  este agendamento.
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <botao
              tipo="button"
              estilo="vazado-verde"
              rotulo="Imprimir"
              icone="fa-print"
              dismiss="modal"
              v-show="protocoloGerado"
              @clicado="imprime()"
            ></botao>
            <botao
              tipo="button"
              estilo="cheio-verde"
              rotulo="Ok"
              icone="ok-modal"
              dismiss="modal"
            ></botao>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Botao from '@/components/botao';

export default {
  name: 'ProtocoloModal',

  props: {
    protocoloGerado: {
      required: false,
      type: String,
    },
    agendamentoId: {
      required: true,
      type: Number,
    },
  },

  methods: {
    imprime() {
      this.$emit('imprimeProtocolo', this.agendamentoId);
    },
  },

  components: {
    Botao,
  },
};
</script>

<style scoped>
.espacado {
  text-align: center;
  margin: 40px 0 15px;
}
</style>



// WEBPACK FOOTER //
// protocolo-modal.vue?8dc1cafa